import { render, staticRenderFns } from "./LinkButton.vue?vue&type=template&id=2187d098&scoped=true&lang=pug&"
import script from "./LinkButton.vue?vue&type=script&lang=ts&"
export * from "./LinkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2187d098",
  null
  
)

export default component.exports